import {
  fetchV1Sizes,
  createV1Size,
  searchV1Sizes,
} from "@/services/v1/inventoryAPIService";

export default {
  state: {
    sizes: [],
    sizePageSize: 5,
    totalSizeCount: 0,
    sizeSearchQuery: "",
  },
  getters: {
    sizes: (state) => state.sizes,
    currentSizePageSize: (state) => state.sizePageSize,
    totalSizeCount: (state) => state.totalSizeCount,
    sizeSearchQuery: (state) => state.sizeSearchQuery,
  },
  mutations: {
    SET_SIZES(state, sizes) {
      state.sizes = sizes;
    },
    SET_SIZE_PAGE_SIZE(state, pageSize) {
      state.sizePageSize = pageSize;
    },
    SET_TOTAL_SIZES_COUNT(state, count) {
      state.totalSizeCount = count;
    },
    SET_SIZE_SEARCH_QUERY(state, query) {
      state.sizeSearchQuery = query;
    },
  },
  actions: {
    async fetchSizes({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Sizes(page, pageSize);
        commit("SET_SIZES", response.results);
        commit("SET_SIZE_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_SIZES_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching sizes:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async searchSizes({ commit }, { query, page = 1, pageSize = 8 } = {}) {
      commit("SET_SIZE_SEARCH_QUERY", query);
      try {
        const response = await searchV1Sizes(query, page, pageSize);
        commit("SET_SIZES", response.results);
        commit("SET_SIZE_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_SIZES_COUNT", response.count);
      } catch (error) {
        console.error("Error searching sizes:", error);
      }
    },
    async addSize({ commit }, size) {
      try {
        const response = await createV1Size(size);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`size create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message = error.response?.data?.message || "Failed to add Size.";
        return { success: false, message };
      }
    },
  },
};
